import React from "react";
import { Tabs, Tab, makeStyles } from "@material-ui/core";

export interface TabItem {
    label: string;
    value: string | number;
}

interface Props {
    tabs: TabItem[];
    value: string | number;
    onChange: (value: string | number) => void;
}

const useStyles = makeStyles((theme) => ({
    tabWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            marginBottom: 0,
        },
    },
    tabContainer: {
        background: "#1F1F1F",
        borderRadius: 10,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            minHeight: 40,
        },
    },
    tab: {
        minWidth: 180,
        maxWidth: 180,
        height: 42,
        borderRadius: 8,
        textTransform: "none",
        fontSize: 20,
        fontWeight: 500,
        color: "#FFFFFF",
        background: "transparent",

        "&:hover": {
            background: "#2A2A2A",
        },

        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
            minWidth: "50%",
            maxWidth: "50%",
            flex: 1,
            padding: "6px 10px",
        },
    },

    activeTab: {
        color: "#FFFFFF",
        background: "#FE5A97",
        fontWeight: 600,
    },
}));

const UniversalTabs: React.FC<Props> = ({ tabs, value, onChange }) => {
    const classes = useStyles();

    const handleChange = (_: React.ChangeEvent<{}>, newValue: any) => {
        onChange(newValue);
    };

    return (
        <div className={classes.tabWrapper}>
            <Tabs
                className={classes.tabContainer}
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{ style: { display: "none" } }}
            >
                {tabs.map((tab) => (
                    <Tab
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                        className={`${classes.tab} ${value === tab.value ? classes.activeTab : ""
                            }`}
                    />
                ))}
            </Tabs>
        </div>
    );
};

export default UniversalTabs;